import { css } from 'lit';
import componentStyles from '../../styles/component.styles';
export default css `
  ${componentStyles}
  /**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
    display: block;
    height: 100%;
  }

  .card {
    height: 100%;
  }

  .content {
    padding-top: 1rem;
  }

  .no-image .content {
    padding-top: 0;
  }

  .hide-content {
    height: auto;
  }

  .hide-content .content {
    display: none;
  }

  /**
--------------------------------------------------
* Image
--------------------------------------------------
*/
  a {
    cursor: pointer;
  }

  .image img {
    max-width: 100%;
    display: block;
  }

  .image a {
    display: block;
    height: 100%;
  }

  /**
--------------------------------------------------
* Ratio
--------------------------------------------------
*/
  .image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  .ratio-none .image {
    aspect-ratio: auto;
  }

  .ratio-none .image img {
    height: auto;
  }

  .ratio-16-9 .image {
    aspect-ratio: 16/9;
  }

  .ratio-3-2 .image {
    aspect-ratio: 3/2;
  }

  .ratio-1-1 .image {
    aspect-ratio: 1/1;
  }

  .ratio-2-3 .image {
    aspect-ratio: 2/3;
  }

  /**
--------------------------------------------------
* Boxed
--------------------------------------------------
*/
  .boxed {
    border: 1px solid var(--p-border);
    background-color: var(--p-boxed-bg);
    border-radius: var(--p-card-boxed-border-radius, 5px);
    overflow: hidden;
  }

  .boxed .content {
    padding: var(--p-card-boxed-padding, 1rem);
  }

  /**
--------------------------------------------------
* Text alignment
--------------------------------------------------
*/
  .text-align-center .content {
    text-align: center;
  }

  .text-align-left .content {
    text-align: left;
  }

  .text-align-right .content {
    text-align: right;
  }

  /**
--------------------------------------------------
* Slotted content
--------------------------------------------------
*/
  slot::slotted(p) {
    --p-p-margin-bottom: 0;
    font-size: var(--p-body-font-size-small, 1rem);
  }

  slot::slotted(p-button-group) {
    margin-top: var(--p-p-margin-bottom);
  }
`;
